import { render } from "./dataShow.vue?vue&type=template&id=3f48ebcc"
import script from "./dataShow.vue?vue&type=script&lang=js"
export * from "./dataShow.vue?vue&type=script&lang=js"

import "./dataShow.vue?vue&type=style&index=0&id=3f48ebcc&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__